import { DateOfBirthExperimental, INPUT_VARIANT } from '@manulife/mux';
import React from 'react';

const DateOfBirth = (props) => {
  return (
    <DateOfBirthExperimental
      disabledDays={{
        after: new Date(),
        before: new Date('January 1 1900'),
      }}
      id="example-date-of-birth"
      onChange={(newValue) => props.onChange(newValue, props.name)}
      value={props.value}
      variant={props.variant || INPUT_VARIANT.BASIC_LINE}
    />
  );
};

export default DateOfBirth;
